export const PageHero = {
  flow: 'y',
  gap: 'A',
  padding: 'C',
  maxWidth: 'L+L',
  width: '100%',
  margin: '0 auto',
  position: 'relative',
  borderBottomWidth: '1px',
  borderBottomColor: 'line',
  borderBottomStyle: 'solid',

  Eyebrow: {
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    fontSize: 'V',
    fontWeight: '700',
    letterSpacing: '.18em',
    color: 'cyan',
    Dot: {
      width: 'V',
      height: 'V',
      round: '50%',
      background: 'cyan'
    },
    Text: { tag: 'span', text: (el) => el.parent.parent.eyebrow || '' }
  },

  Headline: {
    tag: 'h1',
    margin: '0',
    fontSize: 'F1',
    fontWeight: '700',
    letterSpacing: '-.025em',
    lineHeight: '0.95',
    color: 'title',
    text: (el, s) => {
      const h = el.parent.headline
      return typeof h === 'function' ? h(el, s) : h || ''
    }
  },

  Lede: {
    tag: 'p',
    margin: '0',
    maxWidth: 'L',
    fontSize: 'B',
    lineHeight: '1.5',
    fontWeight: '400',
    color: 'subtitle',
    text: (el, s) => {
      const l = el.parent.lede
      return typeof l === 'function' ? l(el, s) : l || ''
    }
  }
}
